import React from 'react';
import { useTheme } from '@material-ui/core/styles';
import Box from '@material-ui/core/Box';
import Typography from '@material-ui/core/Typography';

const OportunidadSection = () => {
  const theme = useTheme();

  return (
    <Box
      sx={{
        py: 4,
        px: 3,
        borderRadius: 2,
        bgcolor: theme.palette.alternate.main,
        borderLeft: 4,
        borderColor: theme.palette.primary.main,
      }}
    >
      <Typography
        sx={{ textTransform: 'uppercase', fontWeight: 700 }}
        variant="overline"
        color="primary"
        display="block"
        gutterBottom
      >
        1. Estrategia central
      </Typography>
      <Typography variant="h5" fontWeight={700} gutterBottom>
        Inbound Marketing: Placer Inteligente, Decisiones Seguras
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        Para <strong>Prudence</strong>, el enfoque de Inbound Marketing se basa en la{' '}
        <strong>educación sexual responsable, el bienestar, el estilo de vida y la prevención</strong>, rompiendo
        tabúes con un tono fresco, profesional, cercano y con <strong>humor inteligente</strong> que conecta sin
        ridiculizar.
      </Typography>
      <Typography variant="body1" color="textSecondary" paragraph>
        No se trata solo de promocionar el producto, sino de posicionar a la marca como la autoridad que acompaña a la
        audiencia en su vida íntima, ofreciendo información confiable y derribando mitos — en antena con{' '}
        <strong>Karla Aleska y Mariana</strong> en <strong>2do Escalón</strong> y en el ecosistema digital de{' '}
        <strong>TNO Network</strong>.
      </Typography>
    </Box>
  );
};

export default OportunidadSection;
